import SEO from "@/common/components/seo";
import { AuthenticationProvider } from "@/common/providers/authentication";
import ArrowRightIcon from "@/common/svgs/arrow-right";
import { Button } from "@/components/ui/button";
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	type CarouselApi,
} from "@/components/ui/carousel";
import { SignUpRoute } from "@/features/authentication/route";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OurPartners from "../../partners/containers/partners";

function Header() {
	return (
		<div
			className="flex h-screen flex-col items-center justify-center"
			style={{
				backgroundImage: "url(/images/header-background.png)",
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			<p className="web-heading-h1 z-3 text-center text-white max-sm:p-4">
				About Reel Rewards
			</p>
			<p className="web-body-b1 mt-4 max-w-[60ch] px-6 text-center text-white-80">
				The community built to help Aussie anglers save more, win more, and fish more.
			</p>
		</div>
	);
}

function AboutUs() {
	return (
		<div className="flex flex-col justify-center gap-8 p-4 py-16 md:gap-12 md:px-37 md:py-50">
			<span className="web-heading-h2 md:text-center">
				About{" "}
				<span
					style={{
						background:
							"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
						WebkitBackgroundClip: "text",
						backgroundClip: "text",
						WebkitTextFillColor: "transparent",
					}}
				>
					Us
				</span>
			</span>

			<div className="flex flex-col items-start gap-6 md:flex-row md:gap-70">
				<p className="web-heading-h4 text-gray-700">
					Connecting Australian anglers through rewards and community
				</p>
				<div className="flex flex-col gap-12">
					<p className="web-body-b2 text-gray-700">
						At Reel Rewards, we’re more than just a platform—we’re a community
						for those who live and breathe fishing. Founded with a passion for
						the great outdoors, our mission is to connect Australian anglers
						with exciting opportunities to save more, win more, and fish more.
						{"\n"} {"\n"}
						From exclusive partner discounts to epic fishing giveaways, we’re
						here to make every adventure more rewarding. Whether you're a
						seasoned pro or just getting started, Reel Rewards helps you access
						the gear, experiences, and community you love—all in one place. Reel
						rewards - Where we work hard to bring you valuable discounts and
						incredible giveaways, ensuring you get the most out of every cast.
						Join us now and start reeling in the rewards!
					</p>
				</div>
			</div>
		</div>
	);
}

function WeWorkHard() {
	return (
		<div className="md:px-25 md:py-17">
			<div
				className="px-4 py-12 md:rounded-[64px] md:px-25 md:py-31"
				style={{
					background:
						"radial-gradient(277.81% 189.47% at 80.08% -45.37%, #2EDBCA 1.3%, #004096 43.8%, #470096 100%)",
				}}
			>
				<div className="flex flex-col items-center gap-3 md:flex-row md:gap-8">
					<span className="web-heading-h2 text-center text-white">
						We work hard to <span className="text-green-300">provide</span> our
						members with exclusive opportunities, from{" "}
						<span className="text-green-300">valuable partner discounts</span>{" "}
						to <span className="text-green-300">fishing giveaways</span>
					</span>
					<img
						src="images/sales.png"
						alt="We Work Hard"
						className="max-h-29 md:max-h-95"
					/>
				</div>
			</div>
		</div>
	);
}

function Partner({
	fullName,
	position,
	image,
}: {
	fullName: string;
	position: string;
	image: string;
}) {
	return (
		<div className="flex flex-col gap-4 md:gap-8">
			<img src={image} className="aspect-square object-contain md:max-h-114" />
			<div className="flex flex-col gap-2">
				<p className="web-heading-h4">{fullName}</p>
				<p className="web-body-b1 text-gray-700">{position}</p>
			</div>
		</div>
	);
}

function TheTeam() {
	const isAuthenticated = AuthenticationProvider.isAuthenticated;

	const [api, setApi] = useState<CarouselApi>();
	const [current, setCurrent] = useState(0);

	useEffect(() => {
		if (!api) {
			return;
		}

		setCurrent(api.selectedScrollSnap() + 1);

		api.on("select", () => {
			setCurrent(api.selectedScrollSnap() + 1);
		});
	}, [api]);

	const partners = [
		{
			fullName: "Joshua",
			image: "images/joshua.png",
			position: "Owner/Founder - Casual Angler",
		},
		{
			fullName: "Matt",
			image: "images/matt.png",
			position: "Support/content creator - “Pro” Angler",
		},
		{
			fullName: "Brodie",
			image: "images/brodie.png",
			position: "Content creator - Master Angler",
		},
	];

	return (
		<div className="flex flex-col items-center gap-8 px-4 py-16 md:gap-16 md:px-25 md:py-30">
			<div className="flex flex-col p-4 text-center">
				<span className="web-heading-h2">
					The{" "}
					<span
						style={{
							background:
								"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
							WebkitBackgroundClip: "text",
							backgroundClip: "text",
							WebkitTextFillColor: "transparent",
						}}
					>
						Team
					</span>
				</span>
				<span className="web-body-b1 text-gray-700">
					One works fifo in the mines, one’s a paramedic, one’s a chippy - all
					united by a passion for fishing
				</span>
			</div>

			<Carousel setApi={setApi} className="w-full p-4 md:hidden">
				<CarouselContent>
					{partners.map((partner) => (
						<CarouselItem>
							<Partner
								key={partner.fullName}
								fullName={partner.fullName}
								image={partner.image}
								position={partner.position}
							/>
						</CarouselItem>
					))}
				</CarouselContent>
			</Carousel>

			<div className="flex items-center justify-center gap-2 md:hidden">
				{Array.from({ length: partners.length }).map((_, index) =>
					current === index + 1 ? (
						<div
							key={index}
							onClick={() => setCurrent(index)}
							className={`h-3 w-3 rounded-full bg-blue-700 transition-all duration-300`}
						></div>
					) : (
						<div
							key={index}
							onClick={() => setCurrent(index)}
							className={`bg-blue-900-20 h-2 w-2 rounded-full transition-all duration-300`}
						></div>
					)
				)}
			</div>

			<div className="hidden flex-row items-end justify-between gap-8 md:flex">
				{partners.map((partner) => (
					<Partner
						key={partner.fullName}
						fullName={partner.fullName}
						image={partner.image}
						position={partner.position}
					/>
				))}
			</div>

			{!isAuthenticated && (
				<Button className="w-full max-sm:mt-4 md:w-44">
					<Link
						to={SignUpRoute}
						className="flex w-full flex-row items-center justify-center"
					>
						Join Now
						<ArrowRightIcon white />
					</Link>
				</Button>
			)}
		</div>
	);
}

export default function AboutUsPage() {
	return (
		<div>
			<SEO
				title="About Us - Reel Rewards"
				description="Learn about Reel Rewards, our mission, and the team behind the fishing community built for rewards, discounts, and giveaways."
			/>
			<Header />
			<OurPartners />
			<AboutUs />
			<WeWorkHard />
			<TheTeam />
		</div>
	);
}
